import { render } from "./MergeDuplicates.vue?vue&type=template&id=43a24c38"
import script from "./MergeDuplicates.vue?vue&type=script&lang=js"
export * from "./MergeDuplicates.vue?vue&type=script&lang=js"

import "./MergeDuplicates.vue?vue&type=style&index=0&id=43a24c38&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__